import React from "react";
import { Field, ErrorMessage } from "formik";
import TextError from "./TextError";
import "./Textarea.styles.scss";

function Textarea(props) {
  const { label, name, sublabel, disabled, required, maxLen, rows, ...rest } = props;
  const validate = (value) => {
    let errorMessage;
    if (value && value.length<3)
      errorMessage = 'Minimum 3 characters required';
    return errorMessage;
  };
  return (
    <>
      <label className="xs-lable-select white" required>
        {label}
        {required ? <span style={{ color: "red" }}>{` *`}</span> : null}
      </label>
      <span
        style={{
          fontSize: "x-small",
          display: "block",
          color: "#646464",
          fontFamily: "JioType-Medium",
        }}
      >
        {sublabel}
      </span>
      <div className="float-label">
        <Field
          maxLength={maxLen}
          validate={validate}
          rows={rows} 
          as="textarea"
          autoComplete="nope"
          style={{ color: `${disabled ? "#707070" : "white"}` }}
          id={name}
          name={name}
          disabled={disabled}
          {...rest}
        />      
        <ErrorMessage component={TextError} name={name} />
      </div>
    </>
  );
}

export default Textarea;
